var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      staticClass: "xtremepush-inbox",
      attrs: {
        "offset-y": "",
        "max-width": _vm.tabletAndAbove ? 300 : 255,
        "min-width": _vm.tabletAndAbove ? 300 : 255,
        left: true,
        bottom: true,
        origin: "center",
        "content-class": _vm.menuContentClass
      },
      model: {
        value: _vm.menu,
        callback: function($$v) {
          _vm.menu = $$v
        },
        expression: "menu"
      }
    },
    [
      _c(
        "v-btn",
        {
          attrs: {
            slot: "activator",
            id: "xtremepushInboxBtn",
            origin: "center center",
            flat: ""
          },
          on: {
            click: function($event) {
              return _vm.inboxClick(_vm.menu)
            }
          },
          slot: "activator"
        },
        [
          _vm.xtremepushInboxBadgeCounter && _vm.xtremepushInboxBadgeCounter > 0
            ? _c("badge", [_vm._v(_vm._s(_vm.xtremepushInboxBadgeCounter))])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "icon-mail" },
            [_c("v-icon", [_vm._v("mail_outline")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.MobilelocalServer
        ? _c("div", { staticClass: "inbox-container" }, [
            _c(
              "div",
              { staticClass: "inbox_header" },
              [
                _c(
                  "v-layout",
                  { attrs: { "align-center": "" } },
                  [
                    _c(
                      "v-flex",
                      { staticClass: "titleInbox", attrs: { xs6: "" } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("XtremePush.Inbox")) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs6: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "cancelMenuBtn",
                            attrs: { flat: "" },
                            on: {
                              click: function($event) {
                                _vm.menu = false
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("XtremePush.Inbox.Close")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.xtremepushMessageList &&
            _vm.xtremepushMessageList !== undefined &&
            _vm.xtremepushMessageList.length > 0
              ? _c(
                  "div",
                  { ref: "inboxWrapperElement", staticClass: "inbox_wrapper" },
                  _vm._l(_vm.xtremepushMessageList, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "inbox_details",
                        class: item.opened === 1 ? "opened" : "",
                        attrs: { "campaign-id": item.message.cid, id: item.id }
                      },
                      [
                        _c("div", { staticClass: "item-container" }, [
                          _c(
                            "div",
                            {
                              staticClass: "clickable-inbox",
                              on: {
                                click: function($event) {
                                  return _vm.inboxMessageClickedOrClosed(
                                    item,
                                    "open"
                                  )
                                }
                              }
                            },
                            [
                              item.message && item.message.icon
                                ? _c("div", { staticClass: "item item-1" }, [
                                    _c("img", {
                                      staticClass: "message-icon",
                                      attrs: { src: item.message.icon }
                                    })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "item item-2",
                                  class: { "remove-pl": !item.message.icon }
                                },
                                [
                                  item.message.title
                                    ? _c("p", {
                                        staticClass: "inbox-item-title",
                                        domProps: {
                                          innerHTML: _vm._s(item.message.title)
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.message.alert
                                    ? _c("p", {
                                        staticClass: "inbox-item-text",
                                        domProps: {
                                          innerHTML: _vm._s(item.message.alert)
                                        }
                                      })
                                    : _vm._e()
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "item item-3" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "close-icon",
                                  on: {
                                    click: function($event) {
                                      return _vm.inboxMessageClickedOrClosed(
                                        item,
                                        "click"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("close")]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "source-and-date" }, [
                          item.message.source
                            ? _c("span", [
                                _vm._v(_vm._s(item.message.source) + " ·")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.create_time
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.inboxFormatDate(item.create_time))
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "emptyXTList" }, [
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("XtremePush.Inbox.Empty"))
                    }
                  })
                ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f8173efe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8173efe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/XtremepushInbox.vue
// module id = null
// module chunks = 